module.exports = __webpack_public_path__ + "img/redis.bde6d4ed.png";